<template>
    <div class="flex flex-col bg-gray-200 p-3">
        <div class="flex justify-between justify-center">
            <h3 class="font-bold mb-2">{{ title }}</h3>
            <button type="button"
                    @click="$inertia.visitInModal(route('sales.orders.edit.address', {order: orderId, address: address.id}))"
                    class="block">
                <PencilIcon class="mr-2 mt-3 h-5 w-5 hover:text-gray-700" />
            </button>
        </div>
        <span class="font-mono" v-if="address.company">{{ address.company }}</span>
        <span class="font-mono" v-if="address.lastname">{{ address.firstname }} {{ address.lastname }}</span>
        <span class="font-mono">{{ address.street }}</span>
        <span class="font-mono" v-if="address.street_ext">{{ address.street_ext }}</span>
        <span class="font-mono">{{ address.zip }} {{ address.city }}</span>
        <span class="font-mono">{{ address.country }}</span>

    </div>
</template>

<script>
import {PencilIcon} from "@heroicons/vue/24/outline";

export default {
    props: ['address', 'title', 'orderId'],
    components: {
        PencilIcon
    }
}
</script>

<style scoped>

</style>
